<style lang="less" scoped>
  @import "../../vars.less";

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 160px;
    text-align: center;
    color: #fff;
  }
  .avatar {
    width: 50px;
    height: 50px;
    border: 2px solid #fff;
    border-radius: 100%;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
  }
  .username {
    margin: 0;
    margin-top: @space-small;
    font-size: 14px;
  }
  .bar {
    display: flex;
    height: 48px;
    color: @text-color;
    font-size: 14px;
    background-color: #fff;
  }
  .bar-item {
    display: flex;
    flex: auto;
    align-items: center;
    justify-content: center;
    padding: @space-small;
    &:not(.disabled):active {
      background-color: @active-background-color;
    }
    &.disabled {
      filter: grayscale(100%);
    }
  }
  .bar-item-icon {
    font-size: 24px;
    margin-right: @space-small;
  }
  .collection {
    color: @warning-color;
  }
  .todo {
    color: @info-color;
  }
  .cells {
    margin-top: @space-normal;
    color: @text-color-secondary !important;
  }
  .btn-container {
    padding: @space-normal;
  }
</style>

<template>
  <div class="profile">
    <div class="header siemens-banner-bg">
      <!-- <div class="avatar">T</div> -->
      <p class="username">{{ userinfo.name }}</p>
    </div>
    <div class="bar">
      <div class="bar-item"
        :class="{ disabled: !$auth('Order') }"
        tabindex="1" @click="() => $auth('Order') && go2('favorite-order-list')">
        <van-icon name="star" class="bar-item-icon collection"/>
        <span>{{ $t('我的收藏') }}</span>
      </div>
      <div class="bar-item" tabindex="1" style="filter: saturate(0%)">
        <van-icon name="todo-list" class="bar-item-icon todo" />
        <span>{{ $t('我的待办') }}</span>
      </div>
    </div>
    <div class="cells">
      <van-cell :title="$t('个人信息')" icon="user-o" is-link @click="() => go2('userinfo')" />
      <van-cell :title="$t('使用手册')" icon="newspaper-o" is-link @click="go2('manual')" />
      <van-cell :title="$t('通知公告')" icon="bullhorn-o" is-link @click="go2('advertisement-list')" />
      <van-cell :title="$t('版本更新')" icon="upgrade" :value="$t('版本') + ' 1.0'" is-link @click="go2('version-info')" />
      <van-cell :title="$t('用户反馈')" icon="edit" is-link @click="go2('feedback')" />
    </div>
    <div class="btn-container">
      <van-button round block plain type="info" size="small"
        @click="logout">{{ $t('退出登录') }}</van-button>
    </div>
  </div>
</template>

<script>
import { Icon, Cell, Button } from 'vant'
import { LS_KEYS } from '../../constants'
import ls from '../../utils/local-storage'

export default {
  name: 'profile',
  components: {
    'van-icon': Icon,
    'van-cell': Cell,
    'van-button': Button
  },
  data () {
    return {
      userinfo: ls.get(LS_KEYS.USERINFO) || {}
    }
  },
  methods: {
    go2 (name) {
      this.$router.push({
        name,
        params: { stackType: 'push' }
      })
    },
    logout () {
      this.$apis.profile.logout()
      ls.remove(LS_KEYS.PGT)
      this.$router.push({
        name: ls.get(LS_KEYS.ENCRYPTED_PWD) ? 'gesture-login' : 'login'
      })
    }
  }
}
</script>
